'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ScreenReaderItemInfo = require('./components/ScreenReaderItemInfo.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ScreenReaderItemInfo).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/shared-screen-reader-item-info/lib/index.js
// module id = 549
// module chunks = 1